<template>
    <nav>
        <ol class="m-0 flex list-none flex-wrap items-center gap-4 p-0">
            <template
                v-for="(breadcrumbRoute, i) in breadcrumbRoutes"
                :key="breadcrumbRoute"
            >
                <li
                    class="font-semibold text-gray-600"
                    :class="i > 0 ? 'hidden md:block' : ''"
                >
                    {{ breadcrumbRoute }}
                </li>
                <li
                    v-if="i !== breadcrumbRoutes.length - 1"
                    class="hidden font-semibold text-gray-600 md:block"
                >
                    /
                </li>
            </template>
        </ol>
    </nav>
</template>

<script setup lang="ts">
import { useRoute } from '#app'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

type BreadcrumbRoute =
    | string
    | {
          translationKey: string
          plural?: number
      }

const route = useRoute()
const { t } = useI18n({ useScope: 'global' })

function resolveBreadcrumbLabel(breadcrumbRoute: BreadcrumbRoute): string {
    // Page meta is evaluated before `useI18n()` in `script setup`, so
    // breadcrumbs store translation descriptors and get resolved here.
    if (typeof breadcrumbRoute === 'string') {
        return breadcrumbRoute
    }

    if (breadcrumbRoute.plural !== undefined) {
        return t(breadcrumbRoute.translationKey, {}, breadcrumbRoute.plural)
    }

    return t(breadcrumbRoute.translationKey)
}

const breadcrumbRoutes = computed(() => {
    if (route.meta.breadcrumb) {
        return (route.meta.breadcrumb as BreadcrumbRoute[]).map(
            resolveBreadcrumbLabel
        )
    }

    return route.fullPath
        .split('/')
        .filter(item => item !== '')
        .filter(item => isNaN(Number(item)))
        .map(item => item.charAt(0).toUpperCase() + item.slice(1))
})
</script>
